import { api } from '../https'
import { CataloguePagesType, PageType } from '../types/servicesTypes/pageTypes'

export class PageService {
  static async getPageById(id: string, abortSignal?: AbortSignal): Promise<PageType> {
    const res = await api.get<PageType>(`/v3/pages/${id}`, { signal: abortSignal })
    return res?.data
  }

  static async getAllPages(limit: number): Promise<CataloguePagesType> {
    const res = await api.get<CataloguePagesType>(`/v3/pages`, {
      params: { limit },
    })
    return res?.data
  }
}
